import Vue from 'vue'
import Vuetify from "vuetify"
// import "element-ui/lib/theme-chalk/index.css"
import "vuetify/dist/vuetify.min.css"
import zhHans from 'vuetify/es5/locale/zh-Hans'
import pl from 'vuetify/src/locale/pl'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.min.css'
import VeeValidate, {
  Validator
} from 'vee-validate';
import zh from 'vee-validate/dist/locale/zh_CN';
import ElementUI from 'element-ui'
// 
import draggable from "vuedraggable";
import VueCookies from "vue-cookies";
import GhCom from "./ghui";

import JsonExcel from 'vue-json-excel';
Vue.component('downloadExcel', JsonExcel);

import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.component('swiper',swiper);
Vue.component('swiperSlide',swiperSlide);

import * as imageconv from './imageconv';
Vue.prototype.common=imageconv;

import UmyUI from 'umy-ui';
import 'umy-ui/lib/theme-chalk/index.css';
Vue.use(UmyUI);

import VideoPlayer from "vue-video-player";
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
Vue.use(VideoPlayer);
Vue.component("draggable", draggable);
Vue.use(ElementUI);
Vue.use(Vuetify, {

  iconfont: 'mdi',
  lang: {
    locales: {
      zhHans,
      pl,

    },
    current: 'zhHans'
  },

});


Vue.use(VeeValidate);
Validator.localize("zh", zh);
Vue.use(VueCookies);
Vue.use(GhCom);